import GameShow from '../components/GameShow';

export default GameShow; 